import {Component, Host, h, Prop, Event, type EventEmitter, Listen} from '@stencil/core';
import { FILTERS_ID_SEPARATOR } from '../../../../../constants/filterConstants';
import type { FilterNode } from '../../../../result-page/facets-build-wrapper/filter-node';

export interface ChipData {
  name: string;
  id: string;
}

@Component({
  tag: 'filters-chips',
  styleUrl: 'filters-chips.scss',
  shadow: true
})
export class FiltersChips {
  @Prop({attribute: 'hidden-facets'}) readonly hiddenFacets: string = '[]';
  @Prop({attribute: 'hidden-first-child-of-facets'}) readonly hiddenFirstChildOfFacets = JSON.stringify([]);
  @Prop({attribute: 'chips-list'}) readonly chipsListProp!: string;

  private chipsList: FilterNode[];

  private hiddenFacetsArray: string[];

  @Event({bubbles: false}) chipRemove: EventEmitter<ChipData>;


  componentWillLoad() {
      this.chipsList = JSON.parse(this.chipsListProp);
      this.hiddenFacetsArray = JSON.parse(this.hiddenFacets);
  }

  componentWillUpdate() {
      this.chipsList = JSON.parse(this.chipsListProp);
  }

  render() {
      const hiddenFirstChildOfFacetsIds = JSON.parse(this.hiddenFirstChildOfFacets);
      return (
        <Host>
          <div
            class={'mb-chips-list'}
          >
            {this.chipsList
              .filter(filterNode => {
                  const nodeUniqueIdArray = filterNode.uniqueId.split(FILTERS_ID_SEPARATOR);
                  return !(hiddenFirstChildOfFacetsIds.includes(nodeUniqueIdArray[0]) && nodeUniqueIdArray.length === 2);
              }).filter(filterNode => {
                  const splitUnique = filterNode.uniqueId.split(FILTERS_ID_SEPARATOR);
                  const facetId = splitUnique[0];
                  return !this.hiddenFacetsArray.includes(facetId);
              })
              .filter(filterNode => {
                  return filterNode.children.length === 0;
              })
              .map(filterNode =>
                <qds-chip
                  class="mb-chips-qds-chip"
                  text={filterNode.displayName}
                  size='small'
                  type="closable"
                  onClick={() => this.chipRemove.emit({name: filterNode.value, id: filterNode.uniqueId})}>
                </qds-chip>
              )}
          </div>
        </Host>
      );
  }
}
